module.exports = __webpack_public_path__ + "img/kodo_farm_small.457565e6.png";